import { render, staticRenderFns } from "./PremiacoesMercado.vue?vue&type=template&id=30349e44&scoped=true"
import script from "./PremiacoesMercado.vue?vue&type=script&lang=js"
export * from "./PremiacoesMercado.vue?vue&type=script&lang=js"
import style0 from "./PremiacoesMercado.vue?vue&type=style&index=0&id=30349e44&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30349e44",
  null
  
)

export default component.exports